import React, { Fragment, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Typography } from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import * as d3 from "d3";
import HoverableIcon from "../../components/Buttons/HoverableIcon ";
import { replaceDynamicValueLabel } from "../../util/utils";
import { store } from "../../util/store";
import ReusableAgGrid from "../../components/AgGrid/AgGrid";

const useStyle = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  titleContainer: {
    width: "100%",
  },
}));

const Drilldown = (props) => {
  const [exportTrigger, setExportTrigger] = useState(0); // Each time we click, the number changes, triggering the useEffect in the child.

  const classes = useStyle();
  const Symbol = store.getState();
  const Currency_Symbol = Symbol.app.user.Currency;

  console.log("DrillDownProps", props);

  let acvLabel = props.acvName ? `${props.acvName}:` : "ACV";
  if (props.Value_Label) {
    acvLabel = replaceDynamicValueLabel(acvLabel, props.Value_Label);
  }

  const onCellClicked = (e) =>
    props.handleSecondLevelDrilldown("drilldownOppId", e.data.Opp_ID);

  const handleExport = () => {
    // Each time we click, the number changes, triggering the useEffect in the child.
    setExportTrigger((prevCount) => prevCount + 1);
  };

  return (
    <Grid container className={classes.root}>
      {props.body ? (
        <React.Fragment>
          <Grid
            container
            justify="space-betweeen"
            className={classes.titleContainer}
            xs={12}
          >
            <Grid
              item
              container
              xs={11}
              justify="flex-start"
              alignItems="flex-end"
            >
              {props.trailingAvarage ? (
                <>
                  {props.showCurrentACV !== "Acv" ? (
                    <Typography
                      variant="body1"
                      style={{
                        fontWeight: "600",
                        padding: "0.3rem",
                        fontSize: "1rem",
                      }}
                    >
                      <>{props.sideCol ? props.sideCol : "Total"}</>
                      &nbsp;&nbsp;&nbsp;&nbsp; # of Opps:{" "}
                      <span data-test="baseInfo-count">
                        {d3.format(",")(props.body.count_acv[0].count)}
                      </span>
                      &nbsp;&nbsp;&nbsp;&nbsp;
                      {`Cur. ${acvLabel}: ${Currency_Symbol}`}
                      <span data-test="baseInfo-current-acv">
                        {d3.format(",")(
                          Math.round(props.body.count_acv[0].currentAcv)
                        )}
                      </span>
                      &nbsp;&nbsp;&nbsp;&nbsp;
                      <>
                        {`Cur. ${acvLabel} Avg. deal size: ${Currency_Symbol}`}
                        <span data-test="baseInfo-avgAcv">
                          {d3.format(",")(
                            Math.round(props.body.count_acv[0].currentAcvAvg)
                          )}
                        </span>
                      </>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Trailing
                      average&nbsp;&nbsp;&nbsp;
                      <>
                        # of Opps:{" "}
                        <span data-test="averageInfo-count">
                          {props.body.count_acv[0].count_avg.toFixed(1)}
                        </span>
                      </>
                      &nbsp;&nbsp;&nbsp;&nbsp;
                      <>
                        {`Cur. ${acvLabel}: ${Currency_Symbol}`}
                        <span data-test="averageInfo-current-acv">
                          {d3.format(",")(
                            Math.round(props.body.count_acv[0].current_acv_avg)
                          )}
                        </span>
                      </>
                    </Typography>
                  ) : (
                    <Typography
                      variant="body1"
                      style={{ fontWeight: "600", padding: "0.3rem" }}
                    >
                      <>{props.sideCol ? props.sideCol : "Total"}</>
                      &nbsp;&nbsp;&nbsp;&nbsp; # of Opps:{" "}
                      <span data-test="baseInfo-count">
                        {d3.format(",")(props.body.count_acv[0].count)}
                      </span>
                      &nbsp;&nbsp;&nbsp;&nbsp;{`${acvLabel}`} :{" "}
                      {`${Currency_Symbol}`}
                      <span data-test="baseInfo-acv">
                        {d3.format(",")(
                          Math.round(props.body.count_acv[0].acv).toString()
                        )}
                      </span>
                      &nbsp;&nbsp;&nbsp;&nbsp;
                      <>
                        Avg. deal size: {`${Currency_Symbol}`}
                        <span data-test="baseInfo-avgAcv">
                          {d3.format(",")(
                            Math.round(props.body.count_acv[0].avg)
                          )}
                        </span>
                      </>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Trailing
                      average&nbsp;&nbsp;&nbsp;
                      <>
                        # of Opps:{" "}
                        <span data-test="averageInfo-count">
                          {props.body.count_acv[0].count_avg.toFixed(1)}
                        </span>
                      </>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                      <>
                        {`${acvLabel}`} : {`${Currency_Symbol}`}
                        <span data-test="averageInfo-acv">
                          {d3.format(",")(
                            Math.round(props.body.count_acv[0].acv_avg)
                          )}
                        </span>
                      </>
                    </Typography>
                  )}
                </>
              ) : props.showLowMidHigh ? (
                <Typography variant="body1" style={{ fontWeight: "600" }}>
                  Number of opportunities:{" "}
                  <span data-test="count">
                    {d3.format(",")(props.body.count_acv[0].count)}
                  </span>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {`${acvLabel}`} :{" "}
                  {`${Currency_Symbol}`}{" "}
                  <span data-test="acv">
                    {d3.format(",")(
                      Math.round(props.body.count_acv[0].acv).toString()
                    )}
                  </span>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  Expected Yield &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Low:
                  {`${Currency_Symbol}`}{" "}
                  <span data-test="low">
                    {d3.format(",")(
                      Math.round(
                        props.body.message.expectedYield.low
                      ).toString()
                    )}
                  </span>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Mid:{" "}
                  {`${Currency_Symbol}`}{" "}
                  <span data-test="mid">
                    {d3.format(",")(
                      Math.round(
                        props.body.message.expectedYield.mid
                      ).toString()
                    )}
                  </span>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; High:{" "}
                  {`${Currency_Symbol}`}{" "}
                  <span data-test="high">
                    {d3.format(",")(
                      Math.round(
                        props.body.message.expectedYield.high
                      ).toString()
                    )}
                  </span>
                </Typography>
              ) : props.showService ? (
                <Typography variant="body1" style={{ fontWeight: "600" }}>
                  Number of opportunities:{" "}
                  <span data-test="count">
                    {d3.format(",")(props.body.count_acv[0].count)}
                  </span>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                  {props.body.count_acv[0].acv !== undefined
                    ? `${acvLabel} : ${Currency_Symbol}`
                    : ""}{" "}
                  {props.body.count_acv[0].acv !== undefined ? (
                    <span data-test="acv">
                      {d3.format(",")(
                        Math.round(props.body.count_acv[0].acv).toString()
                      )}
                    </span>
                  ) : (
                    ""
                  )}{" "}
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  {props.body.count_acv[0].services !== undefined
                    ? `Services: ${Currency_Symbol}`
                    : ""}{" "}
                  {props.body.count_acv[0].services !== undefined ? (
                    <span data-test="services">
                      {d3.format(",")(
                        Math.round(props.body.count_acv[0].services).toString()
                      )}
                    </span>
                  ) : (
                    ""
                  )}{" "}
                </Typography>
              ) : props.nqpScoreCard ? (
                <Typography variant="body1" style={{ fontWeight: "600" }}>
                  Number of opportunities:{" "}
                  <span data-test="count">
                    {d3.format(",")(props.body.count_acv[0].count)}
                  </span>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                  {/* {props.body.count_acv[0].acv !== undefined ? "ACV: $" : ""}{" "} */}
                  {props.body.count_acv[0].acv !== undefined
                    ? `${acvLabel} : ${Currency_Symbol}`
                    : ""}{" "}
                  {props.body.count_acv[0].acv !== undefined ? (
                    <span data-test="acv">
                      {d3.format(",")(
                        Math.round(props.body.count_acv[0].acv).toString()
                      )}
                    </span>
                  ) : (
                    ""
                  )}
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                  {/* {props.body.count_acv[0].acv !== undefined
                    ? "Current ACV: $"
                    : ""}{" "} */}
                  {props.body.count_acv[0].acv !== undefined
                    ? `Current ${acvLabel} : ${Currency_Symbol}`
                    : ""}{" "}
                  {props.body.count_acv[0].currentAcv !== undefined ? (
                    <span data-test="current-acv">
                      {d3.format(",")(
                        Math.round(
                          props.body.count_acv[0].currentAcv
                        ).toString()
                      )}
                    </span>
                  ) : (
                    ""
                  )}
                </Typography>
              ) : (
                <Typography variant="body1" style={{ fontWeight: "600" }}>
                  {props.MeetingsTable
                    ? "Number of Meetings: "
                    : "Number of opportunities: "}
                  <span data-test="count">
                    {d3.format(",")(props.body.count_acv[0].count)}
                  </span>
                  {props.body.count_acv[0].AccountCount && (
                    <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                  )}
                  {props.body.count_acv[0].AccountCount &&
                    `Number of Accounts: ${d3.format(",")(
                      props.body.count_acv[0].AccountCount
                    )}`}
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  {props.body.count_acv[0].Total_Quantity !== undefined
                    ? `Seats: `
                    : ""}{" "}
                  {props.body.count_acv[0].Total_Quantity !== undefined ? (
                    <span data-test="seats">
                      {d3.format(",")(props.body.count_acv[0].Total_Quantity)}
                    </span>
                  ) : (
                    ""
                  )}
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                  {props.body.count_acv[0].acv !== undefined
                    ? `${acvLabel}: ${Currency_Symbol}`
                    : ""}{" "}
                  {props.body.count_acv[0].acv !== undefined ? (
                    <span data-test="acv">
                      {d3.format(",")(
                        Math.round(props.body.count_acv[0].acv).toString()
                      )}
                    </span>
                  ) : (
                    ""
                  )}
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                  {props.body.count_acv[0].expected_acv !== undefined
                    ? `Expected Yield Midpoint: ${Currency_Symbol}`
                    : ""}{" "}
                  {props.body.count_acv[0].expected_acv !== undefined ? (
                    <span data-test="expected_yield">
                      {d3.format(",")(
                        Math.round(
                          props.body.count_acv[0].expected_acv
                        ).toString()
                      )}
                    </span>
                  ) : (
                    ""
                  )}{" "}
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                  {props.body.count_acv[0].prcOfacv !== undefined
                    ? `Expected Yield Midpoint / ACV: `
                    : ""}{" "}
                  {props.body.count_acv[0].prcOfacv !== undefined ? (
                    <span data-test="perc">
                      {Math.round(
                        props.body.count_acv[0].prcOfacv * 100
                      ).toString()}
                      %
                    </span>
                  ) : (
                    ""
                  )}{" "}
                  {props.body.count_acv[0].averageMoveScore !== undefined
                    ? `Average Move Score: `
                    : ""}{" "}
                  {props.body.count_acv[0].averageMoveScore !== undefined ? (
                    <span data-test="avergae">
                      {props.body.count_acv[0].averageMoveScore.toFixed(2)}
                    </span>
                  ) : (
                    ""
                  )}{" "}
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                  {props.body.count_acv[0].drilldownText !== undefined ? (
                    <span data-test="drilldownText">
                      {props.body.count_acv[0].drilldownText}
                    </span>
                  ) : (
                    ""
                  )}{" "}
                </Typography>
              )}
            </Grid>
            <Grid
              direction="column"
              item
              container
              xs={1}
              justify="flex-end"
              alignItems="flex-end"
              alignContent="flex-end"
            >
              <Grid item justify="flex-end" style={{ paddingBottom: "1rem" }}>
                <button style={{ border: "none" }} onClick={handleExport}>
                  <HoverableIcon />
                </button>
              </Grid>
            </Grid>
          </Grid>

          <ReusableAgGrid
            rowData={props.body.opportunities}
            columnConfig={props.body.columns}
            onCellClicked={onCellClicked}
            isExportable={true}
            header={props.header}
            rawColumnDataForExport={props.body.columns}
            exportTrigger={exportTrigger}
          />
        </React.Fragment>
      ) : (
        <Skeleton
          animation="wave"
          variant="rect"
          width="100%"
          height={280}
          style={{ margin: "20px 0px" }}
        />
      )}
    </Grid>
  );
};

export default Drilldown;
